export function AccessDeniedPage({ message }: { message: string }) {
  return (
    <div className="signin-page">
      <div className="signin-card">
        <h1>アクセスできません</h1>
        <p className="muted" style={{ marginBottom: 16 }}>{message}</p>
        <button className="primary" onClick={() => location.reload()}>再試行</button>
      </div>
    </div>
  );
}
